///////////////////////// SUBDOMAINS LIST //////////////////////////
export const SUBDOMAIN_LIST_REQUEST = "SUBDOMAIN_LIST_REQUEST";
export const SUBDOMAIN_LIST_SUCCESS = "SUBDOMAIN_LIST_SUCCESS";
export const SUBDOMAIN_LIST_FAIL = "SUBDOMAIN_LIST_FAIL";
export const SUBDOMAIN_DETAILS_RESET = "SUBDOMAIN_DETAILS_RESET";

export const SUBDOMAIN_DETAILS_REQUEST = "SUBDOMAIN_DETAILS_REQUEST";
export const SUBDOMAIN_DETAILS_SUCCESS = "SUBDOMAIN_DETAILS_SUCCESS";
export const SUBDOMAIN_DETAILS_FAIL = "SUBDOMAIN_DETAILS_FAIL";

///////////////////////// SUBJECTS LIST //////////////////////////
export const SUBJECT_LIST_REQUEST = "SUBJECT_LIST_REQUEST";
export const SUBJECT_LIST_SUCCESS = "SUBJECT_LIST_SUCCESS";
export const SUBJECT_LIST_FAIL = "SUBJECT_LIST_FAIL";
export const SUBJECT_DETAILS_RESET = "SUBJECT_DETAILS_RESET";

export const SUBJECT_DETAILS_REQUEST = "SUBJECT_DETAILS_REQUEST";
export const SUBJECT_DETAILS_SUCCESS = "SUBJECT_DETAILS_SUCCESS";
export const SUBJECT_DETAILS_FAIL = "SUBJECT_DETAILS_FAIL";

